<script>

  import { mapState } from 'vuex'
  import { routeSlugs } from '@/utils/routes-translations'
  import { gtmSendEvent } from '@/utils/gtm-send-event'

  export default {
    data () {
      return {
        articlesSlug: routeSlugs.articles,
        basePath: `${routeSlugs.articles}/categorie/`
      }
    },
    computed: {
      ...mapState({
        categories: state => state.blog.categories
      })
    },
    methods: {
      categoryLink (link) {
        return this.basePath + link
      },
      activeLink (route) {
        if (this.$route.params.slug) {
          return this.$route.path.includes(route) && route !== routeSlugs.articles
        }
        return this.$route.path.includes(route)
      },
      trackEvent (categoryName) {
        gtmSendEvent('articles', 'category-link', categoryName)
      }
    }
  }
</script>

<template>
  <ul class="categories-navigation-list flex whitespace-nowrap overflow-x-auto pb-4 md:justify-center">
    <li>
      <nuxt-link
        :to="articlesSlug"
        class="nav-link"
        :class="{'is-active': activeLink(articlesSlug)}"
      >
        Alles
      </nuxt-link>
    </li>
    <li
      v-for="category in categories"
      :key="category.sys.id"
    >
      <nuxt-link
        :to="categoryLink(category.fields.slug)"
        class="nav-link"
        :class="{'is-active': activeLink(categoryLink(category.fields.slug))}"
        @click.native="trackEvent(category.fields.slug)"
      >
        {{ category.fields.title }}
      </nuxt-link>
    </li>
  </ul>
</template>

<style lang="scss">
.categories-navigation-list {
  li:last-child {
    padding-right: theme("spacing.4");

    @screen md {
      padding-right: theme("spacing.0");
    }
  }

  .nav-link {
    @apply block relative font-bold text-black px-3 pb-2;

    &.is-active, &:hover {
      @apply text-blue-500 underline;
    }
  }
}
</style>
